import Loading from "@/components/loading/loading.vue";
import PentBox from "@/components/pent-box/pent-box.vue";
import { VcsMenuCategory, VcsMenuCategoryPermission } from "@/util/enum";
import { isLinkVisible } from "@/util/func";
import { Paths } from "@/util/paths";
import { GLGlobal, OidcLogin, Permission } from "commonui";
import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import AppSetting from "@/modules/app-settings";
import { Spinner } from "@/commonui/store/modules/spinner";
import { Alert } from "ant-design-vue";
import { fmtMsg } from "commonui";
import { AppNavigationLocale, ConversationTemplateLocale } from "@/locales/localeid";
import { RequiredPermissions } from "@/util/constants";
@Component({
	components: {
		Loading,
		PentBox,
		Alert
	}
})
export default class Dashboard extends Vue {
	public oidcModule = getModule(OidcLogin);
	appSetting = getModule(AppSetting);
	spinModule = getModule(Spinner);
	noPermission = false;
	requiredPermissions = RequiredPermissions;

	mounted() {
		this.checkNoPermission();
	}

	isVisible(p: Permission) {
		if (p.isVisible) {
			return true;
		} else if (p.items?.length) {
			return p.items.some((p) => p.isVisible);
		}
	}

	checkNoPermission() {
		const loginInfo = GLGlobal.loginInfo();
		const anyAllowedPermission = loginInfo.profile.permissions.filter((p) => this.isVisible(p));
		if (!anyAllowedPermission.length) {
			this.noPermission = true;
		}
	}

	get vcsMenuCategory() {
		return VcsMenuCategory;
	}

	get vcsMenuPermissionCategory() {
		return VcsMenuCategoryPermission;
	}

	get applicationPaths() {
		return Paths;
	}

	// Checks permissions generic
	showLink(menuId: VcsMenuCategory, permissionId?: VcsMenuCategoryPermission, superMenuId?: VcsMenuCategory) {
		return isLinkVisible(menuId, permissionId, superMenuId);
	}

	// Checks permission (depended on the View)
	isMenuVisible = (permissions: { menuId: VcsMenuCategory; menuCatId: VcsMenuCategoryPermission }[]) => {
		return permissions.length && permissions.some((e) => this.showLink(e.menuId, e.menuCatId));
	};

	onClick(path: string) {
		return () => this.$router.push(path);
	}

	get appNavigationLocale() {
		return AppNavigationLocale;
	}

	localizedString(id: string, params?: {}) {
		return fmtMsg(id, params);
	}

	get templateLocale() {
		return ConversationTemplateLocale;
	}
}
